import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'toggler',
  templateUrl: './toggler.component.html',
  styleUrls: ['./toggler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TogglerComponent {
  /**
   * Чекбокс включен/чекбокс
   *
   * @type {boolean}
   * @memberof TogglerComponent
   */
  @Input() checked: boolean;

  /**
   * Чекбокс отключен/включен
   *
   * @type {boolean}
   * @memberof TogglerComponent
   */
  @Input() disabled: boolean;

  /**
   * Id
   *
   * @type {string}
   * @memberof TogglerComponent
   */
  @Input() id: string;

  /**
   * Текст лейбла
   *
   * @type {string}
   * @memberof TogglerComponent
   */
  @Input() text: string;

  /**
   * Текст до чекбокса или после
   *
   * @type {('' | 'before' | 'after')}
   * @memberof TogglerComponent
   */
  @Input() labelPosition: '' | 'before' | 'after';

  @Input() name: string;

  /**
   * Чекбокс является обязательным
   *
   * @type {boolean}
   * @memberof TogglerComponent
   */
  @Input() required: boolean;

  /**
   * Спиннер внутри тоглера
   *
   * @type {boolean}
   * @memberof TogglerComponent
   */
  @Input() loading: boolean;

  /**
   * Событие на клик
   *
   * @type {EventEmitter<void>}
   * @memberof TogglerComponent
   */
  @Output() changed: EventEmitter<void> = new EventEmitter();

  public onChange(): void {
    if (!this.disabled) {
      this.changed.emit();
    }
  }
}
